import * as actionTypes from '../constants/actionTypes';
export function setContainerHeight(height) {
    return {
        type: actionTypes.SET_CONTAINER_HEIGHT,
        height: height,
    };
}
